import Point3D from "../math/Point3D";
import BaseComponent from "./BaseComponent";
import GameSprite from "./GameSprite";
import MathUtil from "../utils/MathUtil";

class Physics extends BaseComponent
{


    constructor()
    {
        super();

        this.app = PIXI.app;

        this.position = new Point3D(0, 0, 0);
        this.velocity = new Point3D(0, 0, 0);
        this.acceleration = new Point3D(0, 0, 0);

        this.timeElapsed = 0;

        this.isSpriteRendered = true;
    }


    initPhysics(physicsType, collisionRadius)
    {
        this.physicsActive = true;
        this.physicsType = physicsType;
        this.collisionRadius = collisionRadius;

        //TweenMax.to(this, 5, {delay:1, collisionRadius:collisionRadius*5});

        this.collisions = [];
    }


    setPositionLimits(posMin, posMax)
    {
        this.posMin = posMin;
        this.posMax = posMax;
    }


    setPosition(x,y,z)
    {
        this.position.x = x;
        this.position.y = y;
        this.position.z = z;
    }


    setVelocity(x,y,z)
    {
        this.velocity.x = x;
        this.velocity.y = y;
        this.velocity.z = z;
    }


    changeZVelocity(z)
    {
        this.velocity.x *= -1;
        this.velocity.y *= -1;
        this.velocity.z *= -1;
    }


    setAcceleration(x,y,z)
    {
        this.acceleration.x = x;
        this.acceleration.y = y;
        this.acceleration.z = z;
    }

    setSize(size)
    {
        this.size = size;
    }


    modifySize(delta, mod)
    {
        this.size -= delta*mod;
    }


    getSize()
    {
        return this.size;
    }


    setCollisionRadius(radius)
    {
        this.collisionRadius = radius;
    }


    getCollisionRadius()
    {
        return this.collisionRadius;
    }


    addVelocityModifier(omega, modAmplX, modAmplY)
    {
        this.omega = omega;
        this.modAmplX = modAmplX;
        this.modAmplY = modAmplY;
        this.modifiedVelocity = new Point3D(0,0,0);
        this.modifyVelocity = true;
    }


    setZTriggeredRotation(rotSpeed, rotZThreshold)
    {
        this.rotSpeed = rotSpeed;
        this.rotZThreshold = rotZThreshold;
    }


    setSpriteRendered(isRendered)
    {
        this.isSpriteRendered = isRendered;
    }


    update(delta)
    {
        if (!this.isSpriteRendered) return;
        if (this.stopMove) return;

        this.timeElapsed += delta;

        this.velocity.x += this.acceleration.x * delta;
        this.velocity.y += this.acceleration.y * delta;
        this.velocity.z += this.acceleration.z * delta;

        if (this.modifyVelocity)
        {
            this.modifiedVelocity.x = this.modAmplX * Math.cos(this.omega * this.timeElapsed);
            this.modifiedVelocity.y = this.modAmplY * Math.sin(this.omega * this.timeElapsed);
            this.position.x += (this.modifiedVelocity.x + this.velocity.x) * delta;
            this.position.y += (this.modifiedVelocity.y + this.velocity.y) * delta;
            this.position.z += this.velocity.z * delta;
        }
        else
        {
            this.position.x += this.velocity.x * delta;
            this.position.y += this.velocity.y * delta;
            this.position.z += this.velocity.z * delta;
        }

        let s = this.getEntity().getComponent(GameSprite);
        if (this.position.z < this.rotZThreshold)
        {
            s.sprite.rotation += this.rotSpeed;
            s.setMultiplierRotation(this.rotSpeed);
        }

        if (this.posMin && this.posMax)
        {
            // if (this.position.x < this.posMin.x || this.posMax.x < this.position.x ||
            //     this.position.y < this.posMin.y || this.posMax.y < this.position.y ||
            //     this.position.z < this.posMin.z || this.posMax.z < this.position.z)
            // {
            //     this.getEntity().queueForRemoval = true;
            // }

            let screenCoordinates = this.app.layout.projectGameToScreen(this.position, this.size);
            if (screenCoordinates.x < -s.sprite.width*2 ||
                screenCoordinates.x > this.app.layout.relWidth(100 + this.app.config.viewPadSize) + s.sprite.width*2 ||
                screenCoordinates.y < -s.sprite.height*2 ||
                screenCoordinates.y > this.app.layout.relHeight(100 + this.app.config.viewPadSize) + s.sprite.height*2 ||
                this.position.z < 0 ||
                this.position.z < this.posMin.z || this.posMax.z < this.position.z)
            {
                this.getEntity().queueForRemoval = true;
            }
        }

    }



}


export default Physics;